import TransactionProService from '../transaction-pro-service';
import LocationService from '@/components/location-select/service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { getQRCode, changeSkin } from '@/utils/common.js';
import { landUnitByType } from '@/utils/common.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      landUnitByType: landUnitByType,
      projectList: [], // 列表数据集合
      cityArr: [], // 选择区域集合
      transctionProjectType: [], // 选择类型集合
      transctionListStatus: [], // 项目状态集合
      landPriceList: [{code: '0-50', name: '0-50万'}, {code: '50-100', name: '50-100万'}, {code: '100-200', name: '100-200万'}, {code: '200-500', name: '200-500万'}, {code: '500-1000', name: '500-1000万'}, {code: '1000', name: '1000万及以上'}], // 土地价格集合
      payWayList: [], // 付款方式集合
      // managerThemeList: [], // 经营权主体集合
      // 当前选中的状态
      query: {
        city: '', // 选择区域
        projectType: '', // 选择类型
        status: '', // 项目状态
        sumPrice: 0, // 土地价格
        payType: '', // 付款方式
        // managementSubjectCode: '', // 经营体主权
        pageNum: 1,
        pageSize: 10,
        name: '',
        projectName: ''
      },
      total: 0,
      hotRecommended: [], // 热推项目集合
      projectSubTypeArr: [] // 项目子分类集合
    };
  },
  created() {
  },
  computed: {
    ...mapGetters(['getTenantParams'])
  },
  mounted() {
    // 获取项目状态
    this.getTransctionListStatus();
    // 获取城市集合
    this.getCityList();
    // 获取项目类型
    this.getProjectType();
    // 获取付款方式
    this.getPayType();
    // 获取项目类型
    this.getProjectStatus();
    // this.getManagerType();
    // 获取列表数据
    // this.getTransctionList();
    // 获取热推项目集合
    this.getHotpro();
  },
  methods: {
    changeSkin,
    getQRCode,
    getTransctionList (page) {
      if(page) {
        this.query.pageNum = page.pageNo;
        this.query.pageSize  = page.pageSize;
      }
      const obj = {};
      Object.keys(this.query).forEach(item => {
        // if (item === 'status' && (this.query[item][0] === 'all' || !this.query[item].length)) {
        //   obj.status = this.transctionListStatus.map(item => item.code);
        // } else if (this.query[item] && (this.query[item] !== 'all')) {
        //   obj[item] = this.query[item];
        // }
        if (this.query[item] && (this.query[item] !== 'all')) {
          obj[item] = this.query[item];
        }
      });
      TransactionProService.getTradeProList(obj).then(res => {
        if (res && res.code === '0') {
          this.total = res && res.data.total;
          this.projectList = res && res.data.list;
          this.projectList.forEach(item => {
            if(item.signStatus === 0) {
              // 已成交的状态 已结项 96
              if((70 <= item.status && item.status <= 90) || item.status === 96 || item.status === 53 || item.status === 54) {
                item.status = 70;
              } else if(item.status === 51 ||item.status === 93 || item.status === 94 || item.status === 95){
                item.status = 95;// 已结束的状态
              }
            } else {
              item.status = 50;
            }
          });
        }
      });
    },
    // 选择条件查询
    changeFormValue (key, value) {
      if(key === 'projectName') {
        this.query.sumPrice ='';
        this.query.purchaseBudget ='';
        this.query.projectType ='';
        this.query.status ='';
        this.query.city ='';
        this.query.name='';
        this.query.pageNum =1;
        this.query.pageSize =10;
        this.getTransctionList();
        return;
      }
      // if (key === 'status') {
      //   this.query.status = [value];
      // } else {
      //   this.query[key] = value;
      // }
      this.query[key] = value;
      this.query.projectName = '';
      this.getTransctionList();
    },
    // 清空条件
    resetQuery () {
      this.query = {
        sumPrice: '',
        projectType: '',
        status: '',
        city: '',
        payType: '',
        pageNum: 1,
        pageSize: 10
      };
      this.getTransctionList();
    },
    getProjectType (type) {
      if (type === 1) {
        return require('@/assets/images/common/engineering.png');
      } else if (type === 2) {
        return require('@/assets/images/common/goods.png');
      } else {
        return require('@/assets/images/common/service.png');
      }
    },
    getProjectStatusStyle (status) {
      if (status === 42) {
        return 'background: #F7B500';
      } else if (status === 50) {
        return 'background: #004B7C';
      } else if (status === 51) {
        return 'background: #0DCE03';
      } else if (status === 60) {
        return 'background: #FA5741';
      } else if ([70, 95, 97].includes(status)) {
        return 'background: #383838';
      }
    },
    getTransctionListStatus () {
      TransactionProService.getTransctionListStatus('projectStatus').then(res => {
        if (res && (res.code === '0')) {
          this.transctionListStatus = res && res.data && res.data.purchaseList;
          this.getTransctionList();
        }
      });
    },
    getCityList() {
      let areaCode = localStorage.areaCode || this.getTenantParams.areaCode;
      let defaultLevel = areaCode.length === 4 ? 3 : 4;
      if (areaCode.length === 2) {
        defaultLevel = 2;
      }
      let level = localStorage.level ? Number(localStorage.level) + 2 : defaultLevel;
      LocationService.getLocationList(areaCode, level).then(res => {
        if (res && res.code === '0') {
          this.cityArr = res.data;
          this.cityArr = this.cityArr.filter(item => item.areaName !== '白');
        }
      });
    },
    getProjectStatus () {
      this.transctionProjectType = [
        {code: '1', value: '耕地'},
        {code: '2', value: '林地'},
        {code: '3', value: '水面'},
        {code: '4', value: '四荒'},
        {code: '5', value: '集体建设用地'},
        {code: '6', value: '房屋'},
        {code: '7', value: '设备设施'},
        {code: '8', value: '其他'}
      ];
      // Service.getSelectList('PROJECT_TYPE').then(res => {
      //   if (res && res.code === '0') {
      //     this.transctionProjectType = res.data;
      //   }
      // });
    },
    getPayType () {
      Service.getSelectList('PAY_TYPE').then(res => {
        if (res && res.code === '0') {
          this.payWayList = res.data;
        }
      });
    },
    getHotpro() {
      TransactionProService.selectIndexRecommendProject({
        limitNum: 3
      }).then(res => {
        if(res && res.code === '0') {
          this.hotRecommended = res.data;
        }
      });
    },
    // getManagerType () {
    //   Service.getSelectList('MANAGEMENT_SUBJECT').then(res => {
    //     if (res && res.code === '0') {
    //       this.managerThemeList = res.data;
    //     }
    //   });
    // },
    // 跳转交易项目详情
    goTransDetail(type, status) {
      this.$router.push('detail?id=' + type + '&status=' + status);
    }
  }
};
